var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfrastructureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.342,
    height: 27,
    viewBox: "0 0 36.342 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hierarchy",
    transform: "translate(-2.5 -14.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11760",
    "data-name": "Path 11760",
    d: "M21.677,66.727h3.152a1.264,1.264,0,0,1,1.253,1.253v4.595a1.264,1.264,0,0,1-1.253,1.253H16.551A1.264,1.264,0,0,1,15.3,72.575V67.98a1.264,1.264,0,0,1,1.253-1.253h5.127Zm10.823,0H29.348a1.264,1.264,0,0,0-1.253,1.253v4.595a1.264,1.264,0,0,0,1.253,1.253h8.241a1.264,1.264,0,0,0,1.253-1.253V67.98a1.264,1.264,0,0,0-1.253-1.253H32.5Zm-25.595,0H3.753A1.264,1.264,0,0,0,2.5,67.98v4.595a1.264,1.264,0,0,0,1.253,1.253h8.241a1.264,1.264,0,0,0,1.253-1.253V67.98a1.264,1.264,0,0,0-1.253-1.253H6.905Z",
    transform: "translate(0 -32.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11761",
    "data-name": "Path 11761",
    d: "M41.586,29.671v2.2a.987.987,0,0,1-.987.987h0a.987.987,0,0,1-.987-.987V30.658H28.79v1.217a.987.987,0,0,1-.987.987h0a.987.987,0,0,1-.987-.987V30.658H15.994v1.217a.987.987,0,0,1-.987.987h0a.987.987,0,0,1-.987-.987v-2.2a.99.99,0,0,1,.987-.987H26.816V25.417H21.273a1.561,1.561,0,0,1-1.557-1.557V16.267a1.563,1.563,0,0,1,1.557-1.557h13.06a1.563,1.563,0,0,1,1.557,1.557V23.9a1.561,1.561,0,0,1-1.557,1.557H28.79v3.267H40.6a.926.926,0,0,1,.987.949Z",
    transform: "translate(-7.113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructureIcon);
export default __webpack_public_path__ + "static/media/Infrastructure_icon.66c2c06809e8f4ac2b0a3281b129ba26.svg";
export { ForwardRef as ReactComponent };